import findOcppConfig from '../../lib/findOcppConfig'
import { isConfigReadonly } from '../../lib/is-config-readonly'
import SEMANTIC_VERSIONING_REGEX from '../constants/SemanticVersioning'
import { KeyValue } from '../redux/api/web-api'

export function serialize(obj: unknown, capitalize?: boolean) {
    const str = []

    if (!obj || typeof obj !== 'object') {
        return ''
    }

    const record = obj as Record<string, unknown>

    for (const p in record)
        if (Object.prototype.hasOwnProperty.call(record, p) && typeof record[p] !== 'undefined') {
            let p1 = p
            if (capitalize) p1 = p.charAt(0).toUpperCase() + p.slice(1)

            str.push(encodeURIComponent(p1) + '=' + encodeURIComponent(String(record[p])))
        }
    return str.join('&')
}

export function capitalize(text: string) {
    return text.charAt(0).toUpperCase() + text.slice(1)
}

export const isEuMember = (countryISO2: string) => {
    const EUISO2List = [
        'AT',
        'BE',
        'BG',
        'HR',
        'CY',
        'CZ',
        'DK',
        'EE',
        'FI',
        'FR',
        'DE',
        'GR',
        'HU',
        'IE',
        'IT',
        'LV',
        'LT',
        'LU',
        'MT',
        'NL',
        'PL',
        'PT',
        'RO',
        'SK',
        'SI',
        'ES',
        'SE',
    ]

    return EUISO2List.includes(countryISO2)
}

export const getFailureReasonFromError = (err: unknown) => {
    const status = (err as { status?: unknown } | null)?.status

    if (status === 400) return 'bad_request'
    if (status === 500) return 'server_error'
    if (status === 'FETCH_ERROR') return 'network_error'

    return 'unknown'
}

export const SWEDISH_VAT = 1.25
export const SWEDISH_COUNTRY_CODE = 'SE'
export const SWEDISH_CURRENCY = 'SEK'
export const SWEDISH_LANGUAGE_CODE = 'SV'

export const formatToCurrencyString = (currency: string, value: number, locale = 'sv-SE') => {
    const normalizedCurrency = currency?.trim() ? currency.trim() : 'SEK'
    const formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: normalizedCurrency,
        currencyDisplay: 'narrowSymbol',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    })

    return formatter.format(value)
}

export const convertPriceStringToNumber = (price: string) => {
    return Number((price ?? '0').replace(',', '.')) || 0
}

//convert Fw version to number
export const getFirmwareVersion = (configKeys: KeyValue[] | undefined | null): string => {
    const firmwareVersionConfig = findOcppConfig('FirmwareVersion', configKeys)
    const fwVersionKey = firmwareVersionConfig?.match(SEMANTIC_VERSIONING_REGEX)
    const fwVersion = fwVersionKey ? fwVersionKey[0] : firmwareVersionConfig ?? '0'
    const versionNumber = fwVersion.slice(0, 5)
    return versionNumber
}

//Semantic version comparison

export const compareSemanticVersions = (version1: string | number, version2: string | number): boolean => {
    if (version1 && version2) {
        const v1Components = version1?.toString().split('.').map(Number)
        const v2Components = version2?.toString().split('.').map(Number)

        // Handle cases where version1 or version2 are undefined or empty
        if (!v1Components || !v2Components) {
            return false
        }

        // Make the version arrays the same length by padding with zeros
        while (v1Components.length < v2Components.length) {
            v1Components.push(0)
        }
        while (v2Components.length < v1Components.length) {
            v2Components.push(0)
        }

        // Compare each component of the version numbers
        for (let i = 0; i < Math.max(v1Components.length, v2Components.length); i++) {
            if (v1Components[i] > v2Components[i]) {
                return true
            } else if (v1Components[i] < v2Components[i]) {
                return false
            }
            // If they are equal, continue to the next component
        }
    }
    // If all components are equal, return false
    return false
}

export const earthingSystemReadOnly = (configKeys: KeyValue[] | undefined | null) => {
    return isConfigReadonly('EarthingSystem', configKeys)
}

export const pad = (toPad: string, isReverse: boolean) => {
    let retVal
    let toAdd
    if (toPad.length <= 8) {
        toAdd = 8 - toPad.length
    } else if (toPad.length <= 14) {
        toAdd = 14 - toPad.length
    } else if (toPad.length <= 20) {
        toAdd = 20 - toPad.length
    } else {
        toAdd = toPad.length % 2
    }
    if (isReverse) {
        retVal = toPad + '0'.repeat(toAdd)
    } else {
        retVal = '0'.repeat(toAdd) + toPad
    }
    return retVal
}

export const reverseHex = (hex: string) => {
    const match = hex.match(/[a-fA-F0-9]{2}/g)
    if (match === null) {
        return ''
    }
    return match.reverse().join('')
}
